import "./App.css";
import About from "./components/about/About";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Home from "./components/home/Home";
import { Route, Routes } from "react-router-dom";
import Project from "./components/project/Project";
import appConfig from "./app-config/projects.json";

function App() {
  return (
    <div className="app">
      <>
        <Header></Header>
        <Routes>
          <Route
            path="/"
            element={<Home projects={appConfig.projects} />}
          ></Route>
          <Route path="/contact" element={<About />}></Route>
          {appConfig.projects.map((z) => (
            <Route
              path={"/" + z.title + z.index}
              key={z.title}
              element={Project(z)}
            />
          ))}
          {/* <Route path="/project" element={<Project />}></Route> */}
        </Routes>
        <Footer></Footer>
      </>
    </div>
  );
}

export default App;
